'use client';

import React from 'react';

import GlobalHeader from 'corgi/global-header/components/GlobalHeader';
import SideNav from 'corgi/side-nav/components/SideNav';
import type { GlobalNavigationProps } from 'frontend-utils/global-nav';

import { arePropsNonEmpty } from '@utils/render';

interface HeaderProps extends GlobalNavigationProps {
  hideUSPBarOnMobile?: boolean;
}

const Header = ({ header, sideNav, hideUSPBarOnMobile }: HeaderProps) => (
  <>
    <GlobalHeader {...header} {...(hideUSPBarOnMobile !== undefined && { hideUSPBarOnMobile })} />
    {arePropsNonEmpty(sideNav) && <SideNav {...sideNav} />}
  </>
);

export default Header;
